import Raven from 'raven-js';
import { useCallback, useMemo } from 'react';
import { useDeletePersonalizationMutation, useDeletePersonalizedDefaultMutation } from '../../__generated__/chirp/com/hubspot/personalize/rpc/PersonalizeContentRpc.hooks';
import { useGetPersonalizationStrategyQuery } from '../../__generated__/chirp/com/hubspot/personalize/rpc/PersonalizeRpc.hooks';
export const useDeletePersonalizedContent = ({
  contentId,
  personalizationStrategyId,
  isDeletingDefault
}) => {
  const [deletePersonalizationVariant, {
    loading: isDeleteVariantLoading,
    error: deleteVariantError
  }] = useDeletePersonalizationMutation();
  const [deletePersonalizationDefault, {
    loading: isDeleteDefaultLoading,
    error: deleteDefaultError
  }] = useDeletePersonalizedDefaultMutation();
  const {
    data: personalizationStrategyData,
    loading: strategyFetchIsLoading,
    error: strategyError
  } = useGetPersonalizationStrategyQuery({
    variables: {
      id: personalizationStrategyId
    },
    skip: isDeletingDefault
  });
  const personalizationVariantObjectId = useMemo(() => {
    var _personalizationStrat;
    if (isDeletingDefault) {
      return undefined;
    }
    if (!strategyFetchIsLoading && strategyError) {
      Raven.captureMessage('Failed to fetch personalization strategy', {
        extra: {
          error: strategyError
        }
      });
      return undefined;
    }
    const personalization = personalizationStrategyData === null || personalizationStrategyData === void 0 || (_personalizationStrat = personalizationStrategyData.personalizationStrategy) === null || _personalizationStrat === void 0 || (_personalizationStrat = _personalizationStrat.personalizations) === null || _personalizationStrat === void 0 ? void 0 : _personalizationStrat.find(({
      assetCoordinates: {
        id
      }
    }) => {
      return id === Number(contentId);
    });
    return personalization === null || personalization === void 0 ? void 0 : personalization.id;
  }, [contentId, isDeletingDefault, personalizationStrategyData, strategyFetchIsLoading, strategyError]);
  const deleteSinglePersonalizationVariant = useCallback(() => {
    if (!personalizationVariantObjectId) {
      return Promise.reject(new Error('Cannot delete variant without personalization id'));
    }
    return deletePersonalizationVariant({
      variables: {
        personalizationId: personalizationVariantObjectId
      }
    });
  }, [deletePersonalizationVariant, personalizationVariantObjectId]);

  // TODO: waiting on delete personalization default RPC method
  const deletePersonalizationDefaultAndVariants = useCallback(async () => {
    await deletePersonalizationDefault({
      variables: {
        personalizationStrategyId
      }
    });
  }, [deletePersonalizationDefault, personalizationStrategyId]);
  return useMemo(() => ({
    deletePersonalizedContent: isDeletingDefault ? deletePersonalizationDefaultAndVariants : deleteSinglePersonalizationVariant,
    deleteIsLoading: isDeletingDefault ? isDeleteDefaultLoading : isDeleteVariantLoading,
    deleteError: isDeletingDefault ? deleteDefaultError : deleteVariantError,
    isDeleteReady: isDeletingDefault ? true : !strategyFetchIsLoading && !strategyError && personalizationVariantObjectId
  }), [isDeletingDefault, deletePersonalizationDefaultAndVariants, deleteSinglePersonalizationVariant, isDeleteDefaultLoading, isDeleteVariantLoading, deleteDefaultError, deleteVariantError, strategyFetchIsLoading, strategyError, personalizationVariantObjectId]);
};